import { forwardRef } from 'react';
import styled from 'styled-components';
import { MeetingSummaryCard } from './meetingSummaryCard';
// 内部数据/组件

const Container = styled.div``;
const DirtyMeetingSummaryCardToYQ = () => {
  return (
    <Container style={{ marginTop: 10 }}>
      <MeetingSummaryCard />
    </Container>
  );
};

export default forwardRef(DirtyMeetingSummaryCardToYQ);
